import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PricingTable = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Load Stripe Pricing Table script
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-4">
            <button 
              onClick={() => navigate('/')} 
              className="text-gray-600 flex items-center hover:text-gray-800"
            >
              ← Back
            </button>
            <h1 className="text-3xl font-bold">Pricing Plans</h1>
          </div>
          <button 
            onClick={() => window.open('https://billing.stripe.com/p/login/test_eVaaFi3YE5IbeCA5kk','_blank')}
            className="px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Billing Details
          </button>
        </div>
        
        <stripe-pricing-table 
          pricing-table-id="prctbl_1Qlw67BxP2CG1qPbiHNfdKjG"
          publishable-key="pk_test_51QRyslBxP2CG1qPb5fTkfqNkQtfOdw4jxDrEXRiIt1msi8joZozPgYna0hyn6JVjCDcZao2pmWmwNviqPHC39rj000aqi4eDFW"
        >
        </stripe-pricing-table>
      </div>
    </div>
  );
};

export default PricingTable; 